module.exports = __webpack_public_path__ + "static/img/ie.6d09160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ie.png
// module id = VBIS
// module chunks = 3